import React, { useEffect, useState } from 'react';
import PopUp from '../../PopUp';
import Input from '../../Input';
import Grid from '../../Grid';
import Button from '../../Button';
import Typography from '../../Typography';
interface InsertLinkPopupProps {
  open: boolean;
  onClose: () => void;
  initialText: string;
  onSave: (text: string, url: string) => void;
}
const InsertLinkPopup = ({
  open,
  onClose,
  initialText,
  onSave
}: InsertLinkPopupProps): React.ReactElement => {
  const [text, setText] = useState(initialText);
  const [url, setUrl] = useState('');
  useEffect(() => {
    if (open) {
      setText(initialText);
      setUrl('');
    }
  }, [open, initialText]);
  const isValidUrl = (value: string): boolean => {
    try {
      const parsed = new URL(value);
      return parsed.protocol === 'http:' || parsed.protocol === 'https:';
    } catch {
      return false;
    }
  };
  const handleSave = (): void => {
    if (!isValidUrl(url.trim())) return;
    onSave(text !== '' ? text : url, url.trim());
  };
  return <PopUp open={open} handleOpen={onClose}>
      <Grid container flexDirection="column" gap="16px" width="100%">
        <Grid width="100%" display="flex" flexDirection="column" gap="4px">
          <Typography variant="h5">Text</Typography>
          <Input name="text" placeholder="Text" value={text} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          setText(e.target.value);
        }} />
        </Grid>
        <Grid width="100%" display="flex" flexDirection="column" gap="4px">
          <Typography variant="h5">Link</Typography>
          <Input name="link" placeholder="https://" value={url} onChange={(e_0: React.ChangeEvent<HTMLInputElement>) => {
          setUrl(e_0.target.value);
        }} />
          {url !== '' && !isValidUrl(url.trim()) && <Typography variant="body3" color="error">
              Invalid URL
            </Typography>}
        </Grid>
        <Grid width="100%" display="flex" justifyContent="flex-end">
          <Button variant="filled" scheme="light" onClick={handleSave} disabled={!isValidUrl(url.trim())}>
            Save
          </Button>
        </Grid>
      </Grid>
    </PopUp>;
};
export default InsertLinkPopup;